import { Injectable } from '@angular/core';
import { EmitterService } from '../../services/emitter.service';
import { CASHIER_PAGES, TIME_DELAY_FOR_DEPOSIT_NOTIFICATION } from '../config/cashier.config';
import { Utility } from '../../shared/utility/utility';
import { TranslateService } from '@ngx-translate/core';
import { UserDetailsService } from '../../services/user-details.service';
import { CashierService } from './cashier.service';

@Injectable({
  providedIn: 'root'
})
export class MessageService {

  constructor(private emitterService:EmitterService, 
              private utils:Utility,
              private translateService:TranslateService, private userDetailsService:UserDetailsService,private cashierService:CashierService) { }

  successTransactionMessage(transactionData:any){
    let data ={
      txnAmount:transactionData.txnAmount,
      message:this.translateService.instant('cashierTransaction.successMessage'), 
      status:true,
      amount:transactionData.amount
    }
    this.updateUserEvents(transactionData);
    this.emitterService.broadCastCashierModalState(false);
    this.emitterService.broadCastSuccessNotifcationStatus(data);
    this.emitterService.broadCastDepositeSuccess('');
    setTimeout(()=>{
      this.emitterService.broadCastSuccessNotifcationStatus({status:false});
    },TIME_DELAY_FOR_DEPOSIT_NOTIFICATION);
    this.utils.closeModal('custom_cashier_modal');
    this.resetCashierMethods();
  }
  resetCashierMethods(){
    this.cashierService.piqMethodsList = [];
    this.cashierService.customMethodsList = [];
    this.cashierService.allCashierMethods = [];
  }

  failureTransactionMessage(transactionData=''){
    this.emitterService.broadCastCustomerCashierTransactionStatusChange
    ({
        page:CASHIER_PAGES.PAYEMENT_DETAILS_PAGE, 
        message:this.translateService.instant('cashierTransaction.failureMessage'),
        isLoading:false
      });
  }
  genericTransactionMessage(){
    this.emitterService.broadCastCustomerCashierTransactionStatusChange
    ({
        page:CASHIER_PAGES.PAYEMENT_DETAILS_PAGE, 
        message:this.translateService.instant('cashierTransaction.genericMessage'),
        isLoading:false
      });
  }
 
  pendingNotification(){
 
    // this.emitterService.broadCastCustomerCashierTransactionStatusChange
    // ({
    //     page:CASHIER_PAGES.PAYEMENT_DETAILS_PAGE, 
    //     message:this.translateService.instant('cashierTransaction.onRedirectionMessage'),
    //     isLoading:false
    //   });
  }

  showNotification(){

  }
  updateUserEvents(transactionData){
    let userDetails = this.userDetailsService?.userProfileDetails;
   let currencySymbol = this.userDetailsService.getUserCurrencySymbol();
   let amount = transactionData.amount;;
    if(userDetails?.userStatus != 'real'){
      this.utils.depositGTMevent("userFirstDeposit",  transactionData.transactionId, userDetails?.externalEcrId, parseInt(amount), currencySymbol)
    }else{
      this.utils.depositGTMevent("userDeposited", transactionData.transactionId, userDetails?.externalEcrId, parseInt(amount), currencySymbol);
    }
    this.utils.S2Scalls(userDetails, "deposit", amount);
  }

  
}
